import { render, staticRenderFns } from "./SalesFlashPage.vue?vue&type=template&id=8e96ca00&"
import script from "./SalesFlashPage.vue?vue&type=script&lang=js&"
export * from "./SalesFlashPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports